module.exports = __webpack_public_path__ + "static/media/background.00d055d2.jpg";